import { InceptionV3Model } from "./models/inception_v3.js";
import { MobileNetV2Model } from "./models/mobilenet_v2.js";
import { MobileNetV2MidModel } from "./models/mobilenet_v2_mid.js";
export var DEFAULT_MODELS = [
    MobileNetV2Model,
    MobileNetV2MidModel,
    InceptionV3Model,
];
//# sourceMappingURL=default_models.js.map